import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Success from "./pages/Success";
import TrackOrder from "./pages/TrackOrder";
import { Login, Register } from "./pages/Auth";
import Account from "./pages/Account";
import Admin from "./pages/Admin";
import About from "./pages/About";
import Recipes from "./pages/Recipes";
import RecipeDetail from "./pages/RecipeDetail";
import Safety from "./pages/Safety";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Soar from "./pages/Soar";
import Contact from "./pages/Contact";
import EmailCapturePopup from "./components/EmailCapturePopup";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/success" element={<Success />} />
              <Route path="/track" element={<TrackOrder />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/account" element={<Account />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/about" element={<About />} />
              <Route path="/recipes" element={<Recipes />} />
              {/* Gentle redirects for renamed recipes */}
              <Route
                path="/recipes/forest-walk-diffuser-blend"
                element={<Navigate to="/recipes/calming-walk-forest-diffuser-blend" replace />}
              />
              <Route
                path="/recipes/hearth-home-diffuser-blend"
                element={<Navigate to="/recipes/hearth-light-diffuser-blend" replace />}
              />
              <Route path="/recipes/:slug" element={<RecipeDetail />} />
              <Route path="/safety" element={<Safety />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/soar" element={<Soar />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Layout>
          <Toaster position="top-right" richColors closeButton />
          <EmailCapturePopup />
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
